<div class="hidden-print">
  @if (loadingData) {
    <ebs-spinner [spinnerMessage]="'Quiz loading..'" [faColour]="'#fff'" [boxColour]="'#fff'"
    [boxPadding]="'5px 15px'"></ebs-spinner>
  }
  @if (callFailed && !isOffline) {
    <div>
      <i class="fa fa-fw fa-lg fa-exclamation-circle"> </i> {{failedMessage}}
    </div>
  }
  <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
  <div class="row">
    <div class="col-sm-12">
      <!--another fudge for this editor... wont let me dynamically set the editable value... maybe just disble the save button-->
      <form #theessayform>
        @if (!isOffline) {
          <editor [init]="editorConfig" [disabled]="isOffline" (onDirty)="editing()"
          id="essay-question-{{question.id}}" name="dataGuardModel" (onFocus)="onFocus()" (onKeyPress)="onKey()" [(ngModel)]="dataGuardModel"></editor>
        }
      </form>
      <br/>
      @if (isOffline) {
        <textarea #textareabox style="height: 100%"
        disabled>{{question?.answer?.answerText}}</textarea>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      @if (callFailed) {
        <ebs-notification-multiple [notifications]="notifications"></ebs-notification-multiple>
      }
    </div>
  </div>

  @if (showAnswer && !callFailed) {
    <div class="row">
      <div class="col-sm-12">
        <div ebsTechnicalContent class="text-info" [innerContent]="question.neutralCommentsHtml"></div>
      </div>
    </div>
  }


  @if (!isOffline) {
    <div>
      @if (essaySaved && !callFailed) {
        <div style="color: green">Your answer has been saved</div>
      }
      @if (showAnswer) {
        <hr>
        }
        @if (!isOffline) {
          <button style="margin-left: 5px" class="btn btn-primary float-right" (click)="saveAnswer()">
          Save</button>
        }
        @if (showCancel && !isOffline) {
          <button id="cancelButton" class="btn btn-primary float-right" (click)="revertAnswer()"
          > Cancel</button>
        }
      </div>
    }
    <div class="container" style="padding-bottom: 50px"></div>
  </div>
  <div class="d-none d-print-block">
    <h5>Notes:</h5>
    <p class="essay-question-print-box">

    </p>
  </div>